import { Asset } from './asset';

// TODO: move to other lib
export class AllocationAsset extends Asset {
  public allocation: number;

  constructor(allocation: number, asset: Asset) {
    super(
      asset.token,
      asset.balance,
      asset.price,
      asset.value,
      asset.isTradeable,
      asset.isSellable,
    );
    this.allocation = allocation;
  }
}
